export default "__VITE_ASSET__Hy9pasVb__"